import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { useUserInfoStore } from "@/shared/store/user-info-store";

import { getUserInfoQueryOptions } from "../query-options";
import { useToken } from "../store";

export function useUserInfoQuery() {
  const token = useToken();

  const query = useQuery({
    ...getUserInfoQueryOptions(),
    enabled: !!token,
  });

  useEffect(() => {
    if (!token) {
      useUserInfoStore.getState().setUserInfo(null);
      return;
    }

    if (!query.data) {
      return;
    }

    useUserInfoStore.getState().setUserInfo(query.data);
  }, [token, query.data]);

  return query;
}

export function useUserInfo() {
  return useUserInfoQuery().data ?? null;
}
